import i18n from "i18next";

import { HazardIdEnum, PolicyDetails, LocationRiskAssessment, PageTabs } from "../hazardIdEnum";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const aniaColorRange = ["#f9f9f9", "#21bf50", "#f1d55d", "#e07069"];

export const getANIAHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.WindItaANIA,
    name: "ANIA Wind (ITA)",
    // permissions: ["ANIA_RISK_CARTAPERICOLOSITAVENTO"],
    permissions: [PermissionIdEnum.WindItaANIA],
    colorRange: aniaColorRange,
    description: `${i18n.t("aniaTooltip.windHazard")} ${i18n.t("aniaTooltip.processed")}`,
    label: `ANIA ${i18n.t("riskAssessment.windHazard")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
  {
    cysId: HazardIdEnum.HailItaANIA,
    name: "ANIA Hail (ITA)",
    // permissions: ["ANIA_RISK_GRANDINE"],
    permissions: [PermissionIdEnum.HailItaANIA],
    colorRange: aniaColorRange,
    description: `${i18n.t("aniaTooltip.hail")}  ${i18n.t("aniaTooltip.processed")}`,
    label: `ANIA ${i18n.t("riskAssessment.hail")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
  {
    cysId: HazardIdEnum.LightningStrikeItaANIA,
    name: "ANIA Lightning Strike (ITA)",
    // permissions: ["ANIA_RISK_FULMINI"],
    permissions: [PermissionIdEnum.LightningStrikeItaANIA],
    colorRange: aniaColorRange,
    description: `${i18n.t("aniaTooltip.lightningStrike")}  ${i18n.t("aniaTooltip.processed")}`,
    label: `ANIA ${i18n.t("riskAssessment.lightningStrike")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
  {
    cysId: HazardIdEnum.PrecipitationIta75mmANIA,
    name: "ANIA Precipitations 75 mm (ITA)",
    // permissions: ["ANIA_RISK_PRECIPITAZIONE75"],
    permissions: [PermissionIdEnum.PrecipitationIta75mmANIA],
    colorRange: aniaColorRange,
    description: `${i18n.t("aniaTooltip.precipitation")}  ${i18n.t("aniaTooltip.processed")}`,
    label: `ANIA ${i18n.t("riskAssessment.precipitation")} 75 mm (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
  {
    cysId: HazardIdEnum.SnowIta30cmANIA,
    name: "ANIA Snow 30 cm (ITA)",
    // permissions: ["ANIA_RISK_PRECIPITAZIONE_NEVOSA_30"],
    permissions: [PermissionIdEnum.SnowIta30cmANIA],
    colorRange: aniaColorRange,
    description: `${i18n.t("aniaTooltip.precipitationSnow")}  ${i18n.t("aniaTooltip.processed")}`,
    label: `ANIA ${i18n.t("riskAssessment.precipitationSnow")} 30 cm (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
];
